import { makeStyles } from "@mui/styles";

import theme from "src/theme";

interface ISideStyles {
    sideContainerHeight: number | undefined;
    sideContainerWidth: number | undefined;
}

export const useStyles = makeStyles({
    wrapperToggleIcon: ({
        sideContainerHeight,
        sideContainerWidth,
    }: ISideStyles) => ({
        width: 36,
        height: 36,
        display: "grid",
        placeItems: "center",
        position: "absolute",
        right: 0,
        top: "50%",
        transition: "0.5s ease",
        transform: "translate(50%, -50%)",
        color: "#C6FFE7",
        cursor: "pointer",
        fontSize: 20,
        borderRadius: "50%",
        border: "1px solid #C6FFE7",
        background: "#1B1B1C",
        "&.open": {
            top: 0,
            right: 0,
            transform: "translate(50%, -50%)",
        },
    }),

    icon: {
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        opacity: 1,
        transition: "0.4s ease!important",
        "&.hidden": {
            opacity: 0,
        },
    },
});
